import React from 'react'
import { Button } from '../../../../components/Button/Button'
import { CrossClientScheduledElement } from './CrossClientScheduledElement'
import { CrossClientRowSkeleton } from '../CrossClientRowSkeleton'
import { CrossClientEmptyState } from '../CrossClientEmptyState'
import { type CrossClientScheduledResult } from './useCrossClientScheduled'
import './CrossClientLandingScheduled.scss'

export interface CrossClientLandingScheduledProps {
  scheduled: CrossClientScheduledResult
}

export const CrossClientLandingScheduled: React.FC<CrossClientLandingScheduledProps> = ({ scheduled }) => {
  const { queries, loading, hasMore, loadingMore, showMore } = scheduled

  if (loading) {
    return <CrossClientRowSkeleton count={3} />
  }

  if (!queries.length) {
    return <CrossClientEmptyState message='No scheduled queries yet' />
  }

  return (
    <div className='d-flex flex-column gap-2 w-100'>
      {queries.map((query) => (
        <CrossClientScheduledElement key={query.id} query={query} />
      ))}
      {hasMore ? (
        <Button variant='header' className='button-small zocks-border-0.5 align-self-center' loading={loadingMore} onClick={showMore}>
          Show more…
        </Button>
      ) : null}
    </div>
  )
}
